function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  id: "a",
  d: "M19.469 9.635L9.593 17.13A1.5 1.5 0 0 0 9 18.325V28.49a1.5 1.5 0 0 0 1.5 1.5h2.872v3H10.5a4.5 4.5 0 0 1-4.5-4.5V18.325a4.5 4.5 0 0 1 1.78-3.585l11.382-8.638a.5.5 0 0 1 .604-.001l11.444 8.637A4.5 4.5 0 0 1 33 18.33v1.102h-3V18.33a1.5 1.5 0 0 0-.597-1.198l-9.934-7.497zm-4.533 11.352v18h24v-18h-24zm0-3h24a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3h-24a3 3 0 0 1-3-3v-18a3 3 0 0 1 3-3zm16.5 6v-4.5h3v7a.5.5 0 0 1-.5.5h-14a.5.5 0 0 1-.5-.5v-7h3v4.5h9zm-12 12a1.5 1.5 0 0 1 0-3h3a1.5 1.5 0 1 1 0 3h-3z"
});

var SvgDeliveryThirdParty = function SvgDeliveryThirdParty(props) {
  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref);
};

export default SvgDeliveryThirdParty;


//////////////////
// WEBPACK FOOTER
// ./src/icons/shipment-status/delivery-third-party.svg
// module id = 173
// module chunks = 0 1